import { DOM } from '../../util/dom';
const LEFT_BUTTON = 0;
const RIGHT_BUTTON = 2;
// the values for each button in MouseEvent.buttons
const BUTTONS_FLAGS = {
    [LEFT_BUTTON]: 1,
    [RIGHT_BUTTON]: 2
};
function buttonNoLongerPressed(e, button) {
    const flag = BUTTONS_FLAGS[button];
    return e.buttons === undefined || (e.buttons & flag) !== flag;
}
export class MouseMoveStateManager {
    constructor(options) {
        this._correctEvent = options.checkCorrectEvent;
    }
    startMove(e) {
        const eventButton = DOM.mouseButton(e);
        this._eventButton = eventButton;
    }
    endMove(_e) {
        delete this._eventButton;
    }
    isValidStartEvent(e) {
        return this._correctEvent(e);
    }
    isValidMoveEvent(e) {
        // Some browsers don't fire a `mouseup` when the mouseup occurs outside
        // the window or iframe:
        // https://github.com/mapbox/mapbox-gl-js/issues/4622
        //
        // If the button is no longer pressed during this `mousemove` it may have
        // been released outside of the window or iframe.
        return !buttonNoLongerPressed(e, this._eventButton);
    }
    isValidEndEvent(e) {
        const eventButton = DOM.mouseButton(e);
        return eventButton === this._eventButton;
    }
}
export class OneFingerTouchMoveStateManager {
    constructor() {
        this._firstTouch = undefined;
    }
    _isOneFingerTouch(e) {
        return e.targetTouches.length === 1;
    }
    _isSameTouchEvent(e) {
        return e.targetTouches[0].identifier === this._firstTouch;
    }
    startMove(e) {
        const firstTouch = e.targetTouches[0].identifier;
        this._firstTouch = firstTouch;
    }
    endMove(_e) {
        delete this._firstTouch;
    }
    isValidStartEvent(e) {
        return this._isOneFingerTouch(e);
    }
    isValidMoveEvent(e) {
        return this._isOneFingerTouch(e) && this._isSameTouchEvent(e);
    }
    isValidEndEvent(e) {
        return this._isOneFingerTouch(e) && this._isSameTouchEvent(e);
    }
}
//# sourceMappingURL=drag_move_state_manager.js.map